/* One craft for every control, written once.
 *
 * The orange main action is lit: a gradient from its top light, its own edge, a glow. Every
 * other control is made the same way in a quieter material, so the page reads as one set:
 *
 * - a CONTROL stands on the page: a faint top-to-base gradient, a hairline edge, a lit top
 *   and a contact shadow; hover lifts it, a press seats it;
 * - a FIELD is sunk into the page: the page's own ground inside an edge, a soft inner
 *   shadow, and an orange halo with an orange edge while it has focus;
 * - a TRACK holds a choice of several (tabs, segments): sunk like a field, and the THUMB
 *   on it, the current choice, stands on it like a control;
 * - a POPOVER (menu, select, command menu) floats above everything, and its ITEMs carry an
 *   icon slot that wakes with the item.
 *
 * Primitives compose these; a page never restyles them. */

export const CONTROL_SURFACE =
  "border border-input bg-gradient-to-b from-card to-secondary/70 shadow-control hover:border-foreground/30 hover:to-secondary hover:shadow-control-hover active:shadow-control-pressed active:to-secondary";

/** The focus mark every field and track shares: the orange edge and a soft orange halo. */
export const FIELD_FOCUS =
  "focus-visible:outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/20 focus-visible:ring-offset-0";

export const FIELD_SURFACE =
  "border border-input bg-background shadow-field hover:border-foreground/25";

export const TRACK_SURFACE = "rounded-lg border border-border/70 bg-muted shadow-well";

export const THUMB_SURFACE = "rounded-md bg-card shadow-control ring-1 ring-border";

export const POPOVER_SURFACE =
  "rounded-xl border border-border bg-popover/95 text-popover-foreground shadow-float";

/** A menu row: 28 px, an icon slot in the quiet ink that wakes with the row, and the
 *  highlighted row lifted in the accent fill. */
export const MENU_ITEM =
  "gap-2 rounded-md [&_svg]:size-4 [&_svg]:shrink-0 [&_svg]:text-muted-foreground focus:bg-accent focus:text-foreground focus:[&_svg]:text-foreground data-[highlighted]:bg-accent data-[highlighted]:text-foreground data-[highlighted]:[&_svg]:text-foreground";

/** The orange mark an active choice's icon takes (the `contextual` icon tone reads it). */
export const ACTIVE_ICON = "[--icon-accent:hsl(var(--brand))]";
